// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__vKw2M","search":"Settings_search__3m9-l","filter":"Settings_filter__3iKRo"};